// extracted by mini-css-extract-plugin
export var locationCard = "_ga-0";